export const NAME = 'TIMEZONE';

export const getTimezones = (store) => store[NAME].list;
